<template>
  <div class="gzLive_bodyMinHeight pro-main">
    <div
      style="
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        z-index: 999;
        background-color: #fff;
        padding: 15px;
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
      "
    >
      <!-- 搜索框 -->
      <div
        class="search-container"
        style="max-width: 400px; margin: 0 auto; display: flex; align-items: center"
      >
        <Input
          placeholder="搜索产品"
          v-model="searchContent"
          style="width: 100%"
          @on-enter="handleSearch"
        />
        <Button
          slot="append"
          type="primary"
          style="border-radius: 0 4px 4px 0"
          @click="handleSearch"
        >
          搜索
        </Button>
      </div>

      <!-- 顶部筛选工具栏 -->
      <div class="filter-tool">
        <div class="tool-left">
          <div class="tag-scroll">
            <div
              class="tag"
              v-for="(item, index) in Category"
              :key="item.id"
              :class="{ active: exOptionCategoryIdName === item.name }"
              @click="selectCategory(item.id, item.name)"
              :data-id="item.id"
            >
              {{ item.name }}
            </div>
          </div>
        </div>
        <button class="menu-btn" @click="showPopup = true">☰</button>
      </div>

      <!-- 底部弹窗 -->
      <div class="filter-popup" :class="{ show: showPopup }" @click.self="closePopup">
        <div class="popup-content">
          <div class="popup-header">
            产品类别
            <button class="close-btn" @click="closePopup">✕</button>
          </div>
          <div class="popup-body">
            <div
              class="category-item"
              v-for="(item, index) in Category"
              :key="item.id"
              :class="{ active: exOptionCategoryIdName === item.name }"
              @click="tempSelectCategory(item.id, item.name)"
            >
              {{ item.name }}
            </div>
          </div>
          <div class="popup-footer">
            <button class="popup-btn btn-reset" @click="resetSelection">重置</button>
            <button class="popup-btn btn-confirm" @click="confirmSelection">确定</button>
          </div>
        </div>
      </div>
    </div>

    <!-- 产品列表 -->
    <div class="pro-list" v-if="proList && proList.length > 0">
      <div
        class="pro-list-one"
        v-for="(item, idx) in proList"
        :key="idx"
        @click="linkToProduct(item.id)"
      >
        <div class="ms-bg">
          <img :src="item.banner[0]" v-if="item.banner[0]" class="ms-bg_banner" />
          <img
            class="ms-bg_banner"
            src="https://huizhanren.oss-cn-shanghai.aliyuncs.com/cloudExhibition/imgs/202004/0068424a368642bc876d127aa9603888.png"
            v-else
          />
          <div class="tags" v-if="item.category && item.category.Value">
            <span>{{ item.category.Value }}</span>
          </div>
        </div>
        <div class="ms-content">
          <p>{{ item.name }}</p>
          <div class="ms-txt">
            <p>{{ item.compName }}</p>
          </div>
        </div>
      </div>
    </div>

    <!-- 空数据提示 -->
    <div class="no-data" v-if="proList && proList.length === 0 && !loading">
      <p>暂无数据</p>
    </div>

    <!-- 没有更多数据的提示 -->
    <div class="no-more-data" v-if="noMoreData && proList && proList.length > 0">
      没有更多了
    </div>

    <!-- 加载中的提示 -->
    <div class="loading-data" v-if="loading">加载中...</div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
let moment = require("moment");

export default {
  name: "mobilePcLive",
  data() {
    return {
      Category: [],
      activeIndex: 0,
      listLive: [],
      proList: [],
      urlHttp: "https://www.cmef.com.cn",
      pageIndex: 1,
      pageSize: 10,
      loading: false, // 是否正在加载
      noMoreData: false, // 是否没有更多数据
      searchContent: "", // 搜索内容
      searchTimer: null, // 搜索防抖定时器

      showPopup: false,
      selectedCategoryId: "",
      exOptionCategoryIdName: "全部",
    };
  },
  computed: {
    optWhere() {
      let opt = {
        PageSize: this.pageSize,
        PageIndex: this.pageIndex,
        ExhibitionIdStr:
          "3ced0899-cfd3-4735-83e3-f4fc2241f028,034cf342-a72a-49bc-b3fb-5239e105e4cb,8de82036-9105-4426-bb2d-237fc5bc195a",
        other: 1,
      };
      return opt;
    },
  },
  created() {
     document.title = "健康生活";
    this.init();
    this.getCategory();
  },
  mounted() {
    // 监听页面滚动事件
    this.bindScrollEvent();
  },
  beforeDestroy() {
    // 移除滚动事件监听
    this.removeScrollEvent();
    // 清除搜索定时器
    if (this.searchTimer) {
      clearTimeout(this.searchTimer);
    }
  },
  methods: {
    ...mapActions({
      getProductLiveShort: "exhibitionModule/getProductLiveShort",
      getProCategory: "exhibitionModule/getProCategory",
    }),

    // 初始化数据
    async init() {
      this.pageIndex = 1;
      this.proList = [];
      this.noMoreData = false;
      await this.loadMoreData();
    },

    // 处理搜索
    handleSearch() {
      // 设置防抖，避免频繁搜索
      this.pageIndex = 1;
      this.proList = [];
      this.noMoreData = false;
      this.loadMoreData();
    },

    // 加载更多数据
    async loadMoreData() {
      if (this.loading || this.noMoreData) {
        return;
      }

      this.loading = true;

      try {
        let optData = {
          PageSize: this.pageSize,
          PageIndex: this.pageIndex,
          Wheres: {
            type: 0,
            wheres: {
              WhereGroupOperator: 0, // 0是或 1是且
              Predicates: [
                {
                  type: 1,
                  wheres: {
                    WhereOperator: 6,
                    Label: "Name",
                    Value: "%" + this.searchContent + "%",
                  },
                },
              ],
            },
          },
          ExhibitionIdStr:
            "3ced0899-cfd3-4735-83e3-f4fc2241f028,034cf342-a72a-49bc-b3fb-5239e105e4cb,8de82036-9105-4426-bb2d-237fc5bc195a,3fa85c95-2fd7-42b7-a3a6-cf45fb36ba45",
          other: 1,
          categoryName:
            this.exOptionCategoryIdName == "全部" ? "" : this.exOptionCategoryIdName,
        };

        let data = await this.getProductLiveShort(optData);

        if (data && data.length > 0) {
          // 如果返回的数据少于pageSize，说明没有更多数据了
          if (data.length < this.pageSize) {
            this.noMoreData = true;
          }

          // 如果是第一页，直接替换数据；否则追加数据
          if (this.pageIndex === 1) {
            this.proList = data;
            // 在数据加载并设置 this.proList 后，滚动到页面顶部
            window.scrollTo({
              top: 0,
              behavior: "smooth", // 可选，平滑滚动
            });
          } else {
            this.proList = [...this.proList, ...data];
          }

          this.pageIndex++;
        } else {
          // 没有数据返回，说明没有更多数据了
          this.noMoreData = true;
        }
      } catch (error) {
        console.error("加载数据失败:", error);
        this.$Message.error("加载数据失败，请重试");
      } finally {
        this.loading = false;
      }
    },

    // 绑定滚动事件
    bindScrollEvent() {
      this.$nextTick(() => {
        window.addEventListener("scroll", this.handleScroll);
      });
    },

    // 移除滚动事件
    removeScrollEvent() {
      window.removeEventListener("scroll", this.handleScroll);
    },

    // 处理滚动事件
    handleScroll() {
      // 如果正在加载或没有更多数据，不处理滚动
      if (this.loading || this.noMoreData) {
        return;
      }

      // 获取滚动相关参数
      const scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;
      const windowHeight = window.innerHeight || document.documentElement.clientHeight;
      const documentHeight =
        document.documentElement.scrollHeight || document.body.scrollHeight;

      // 当滚动到距离底部100px时开始加载
      if (scrollTop + windowHeight >= documentHeight - 100) {
        this.loadMoreData();
      }
    },

    linkToProduct(id) {
      // 您的跳转逻辑
      console.log("跳转到产品详情:", id);
      // 这里可以添加路由跳转逻辑，例如：
      // this.$router.push(`/product/${id}`);
    },

    async getCategory() {
      let data = await this.getProCategory();
      this.Category = data;

      this.Category.unshift({
        id: "111111111111111111111",
        name: "全部",
      });
    },

    // 修改selectCategory方法
    selectCategory(id, name) {
      this.selectedCategoryId = id;
      this.exOptionCategoryIdName = name;
      this.init(); // 重新加载列表数据

      this.$nextTick(() => {
        const scrollContainer = this.$el.querySelector(".tag-scroll");
        if (!scrollContainer) return;

        let activeTag = null;
        if (id === "") {
          activeTag = scrollContainer.querySelector('.tag[data-id="all"]'); // 匹配 "全部"
        } else {
          activeTag = scrollContainer.querySelector(`.tag[data-id="${id}"]`);
        }

        if (activeTag) {
          const containerWidth = scrollContainer.clientWidth;
          const tagLeft = activeTag.offsetLeft;
          const tagWidth = activeTag.clientWidth;
          scrollContainer.scrollTo({
            left: tagLeft - containerWidth / 2 + tagWidth / 2,
            behavior: "smooth",
          });
        }
      });
    },
    tempSelectCategory(id, name) {
      this.selectedCategoryId = id;
      this.exOptionCategoryIdName = name;
    },
    resetSelection() {
      this.selectedCategoryId = "";
      this.exOptionCategoryIdName = "全部";
      this.closePopup();
      this.init();

      // 滚动标签容器到最左边，让“全部”靠左对齐
      this.$nextTick(() => {
        const scrollContainer = this.$el.querySelector(".tag-scroll");
        if (scrollContainer) {
          scrollContainer.scrollTo({
            left: 0,
            behavior: "smooth", // 可选，去掉也可以
          });
        }
      });
    },
    confirmSelection() {
      this.selectedCategoryId = this.selectedCategoryId;
      this.exOptionCategoryIdName = this.exOptionCategoryIdName;
      this.closePopup();

      // 添加以下代码实现滚动定位
      this.$nextTick(() => {
        const scrollContainer = this.$el.querySelector(".tag-scroll");
        const activeTag = this.$el.querySelector(
          `.tag[data-id="${this.selectedCategoryId}"]`
        );

        if (scrollContainer && activeTag) {
          // 计算需要滚动的距离
          const containerWidth = scrollContainer.clientWidth;
          const tagLeft = activeTag.offsetLeft;
          const tagWidth = activeTag.clientWidth;

          // 滚动到选中标签，使其居中显示
          scrollContainer.scrollTo({
            left: tagLeft - containerWidth / 2 + tagWidth / 2,
            behavior: "smooth",
          });
        }
      });
      this.init();
    },
    closePopup() {
      this.showPopup = false;
      // 重置临时选择
      this.selectedCategoryId = this.selectedCategoryId;
      this.exOptionCategoryIdName = this.exOptionCategoryIdName;
    },
  },
};
</script>

<style scoped lang="scss">
.gzLive_bodyMinHeight {
  //   min-height: 1800px;
  background: #f5f5f5;
}

.pro-main {
  padding: 0 15px;
}

// 搜索容器样式
.search-container {
  //   padding: 20px 0;
  //   text-align: center;

  ::v-deep .ivu-input-wrapper {
    .ivu-input {
      border-radius-left: 20px;
      height: 36px;
      line-height: 36px;

      &:focus {
        box-shadow: 0 0 0 2px rgba(24, 144, 255, 0.2);
      }
    }

    .ivu-icon-ios-search {
      color: #999;
    }
  }
}

.pro-list {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  margin-top: 140px;

  .pro-list-one {
    width: calc(50% - 7.5px);
    background-color: #fff;
    border-radius: 5px;
    margin-bottom: 15px;
    cursor: pointer;
    transition: transform 0.2s ease;

    &:hover {
      transform: translateY(-2px);
      box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
    }

    .ms-bg {
      height: 112px;
      border-radius: 5px 5px 0px 0px;
      position: relative;
      border-bottom: solid 1px #dce4ec;

      .live {
        position: absolute;
        right: 10px;
        top: 10px;
        width: 45px;
        height: 15px;
        border-radius: 2px;
        z-index: 2;
      }

      &_banner {
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        margin: auto;
        width: 100%;
        max-height: 100%;
        border-radius: 5px 5px 0px 0px;
        object-fit: cover;
      }

      .tags {
        position: absolute;
        left: 0;
        bottom: 0;
        display: block;
        width: 100%;
        height: calc(36vw / 7.5);
        text-align: right;
        padding: 0 20px;
        background-image: linear-gradient(0deg, #030000 0%, #fff 100%);
        opacity: 0.5;
        color: #fff;
        box-sizing: border-box;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;

        span {
          display: inline-block;
          margin-right: 5px;
          font-size: calc(12vw / 7.5);
        }
      }
    }

    .ms-content {
      padding: 10px;

      p {
        margin-bottom: 6px;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        font-size: 15px;
        font-weight: 500;
        color: #333;
      }

      .ms-txt {
        display: flex;
        align-items: center;

        p {
          max-width: 90%;
          font-size: 12px;
          color: #999;
          margin-bottom: 0;
        }

        .time {
          color: #16d1d1;
        }

        i {
          color: #999;
          font-size: 22px;
          transform: rotate(-90deg);
          margin-left: 2px;
        }
      }
    }
  }
}

// 空数据提示样式
.no-data {
  text-align: center;
  padding: 180px 20px;
  color: #999;
  font-size: 14px;
  background: #f5f5f5;

  p {
    font-size: 16px;
  }
}

// 没有更多数据的样式
.no-more-data {
  text-align: center;
  padding: 20px;
  color: #999;
  font-size: 14px;
  background: #f5f5f5;
}

// 加载中的样式
.loading-data {
  text-align: center;
  padding: 180px 0;
  color: #1890ff;
  font-size: 14px;
  background: #f5f5f5;
}

/* 顶部筛选工具栏 */
.filter-tool {
  position: fixed;
  top: 65px;
  left: 0;
  right: 0;
  background: #fff;
  box-shadow: 0 6px 8px rgba(0, 0, 0, 0.1);
  z-index: 1000;
  padding: 10px 15px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 60px;
}

.tool-left {
  flex: 1;
  overflow: hidden;
}

.tag-scroll {
  display: flex;
  gap: 8px;
  white-space: nowrap;
  overflow-x: auto;
  padding-bottom: 5px; /* 滚动条空间 */
}

.tag {
  display: inline-block;
  padding: 6px 12px;
  background: #f0f0f0;
  color: #666;
  border-radius: 15px;
  font-size: 14px;
  white-space: nowrap;
}

.tag.active {
  background: #ee1c5d;
  color: #fff;
}

.menu-btn {
  background: none;
  border: none;
  font-size: 20px;
  color: #999;
  cursor: pointer;
  padding: 5px;
}

/* 底部弹窗 Modal */
.filter-popup {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  z-index: 2000;
  display: none; /* 默认隐藏 */
  align-items: flex-end;
  justify-content: center;
}

.filter-popup.show {
  display: flex;
}

.popup-content {
  background: #fff;
  width: 100%;
  max-height: 50vh;
  border-radius: 20px 20px 0 0;
  display: flex;
  flex-direction: column;
}

.popup-header {
  padding: 20px;
  font-size: 18px;
  font-weight: bold;
  text-align: center;
  border-bottom: 1px solid #eee;
  position: relative;
}

.close-btn {
  position: absolute;
  right: 20px;
  top: 50%;
  transform: translateY(-50%);
  background: none;
  border: none;
  font-size: 20px;
  color: #999;
  cursor: pointer;
}

.popup-body {
  flex: 1;
  overflow-y: auto;
  padding: 20px;
}

.category-item {
  //   display: block;
  //   width: 100%;
  //   padding: 12px 16px;
  //   margin-bottom: 8px;
  //   background: #f5f5f5;
  //   border: 1px solid #e0e0e0;
  //   border-radius: 20px;
  //   text-align: center;
  //   font-size: 16px;
  //   color: #333;
  //   cursor: pointer;

  padding: 10px 15px;
  display: inline-block;
  background-color: #f5f5f5;
  border-radius: 37px;
  border: solid 1px #f5f5f5;
  margin-right: 10px;
  margin-bottom: 10px;
  font-size: 16px;
  color: #333;
  line-height: 1;
}

.category-item.active {
  background: #f0e6f7;
  border-color: #ee1c5d;
  color: #ee1c5d;
}

.popup-footer {
  display: flex;
  padding: 15px 20px 30px;
  gap: 10px;
}

.popup-btn {
  flex: 1;
  padding: 12px;
  border: none;
  border-radius: 8px;
  font-size: 16px;
  cursor: pointer;
}

.btn-reset {
  background: #f0f0f0;
  color: #666;
}

.btn-confirm {
  background: #ee1c5d;
  color: #fff;
}

.ivu-btn-primary {
  background-color: #ee1c5d;
  border-color: #ee1c5d;
}
</style>
